import React from 'react';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';
import Input from '../components/general/Input';
import Button from '../components/general/Button';
import TestimonialsImage from "../assets/hire-developer/Testimonials.png";
import Image from '../components/general/Image';

const LoginRegister = () => {
    return (
        <>
            <Header />
            <div className="flex flex-col md:flex-row items-center justify-between min-h-screen bg-black --layout-padding">
                {/* Left Part */}
                <div className="max-w-4xl w-full lg:w-[50%] p-6 rounded-lg shadow-md bg-[#292929]">
                    <h1 className="text-3xl font-bold text-center text-white">Login</h1>
                    <p className="mt-4 text-center text-white">
                        Welcome back! Please log in to your account.
                    </p>

                    <form className="mt-8 space-y-6">
                        <div>
                            <Input
                                type="email"
                                label={"Email"}
                                className='bg-transparent border border-gray-300 rounded-md p-[10px] outline-none w-full h-[40px]'
                                placeholder='Email'
                            />
                        </div>
                        <div>
                            <Input
                                type="password"
                                label={"Password"}
                                className='bg-transparent border border-gray-300 rounded-md p-[10px] outline-none w-full h-[40px]'
                                placeholder='Password'
                            />
                        </div>
                        <div>
                            <Button
                                type="submit"
                                className="w-full py-2 px-4 bg-primary-color text-black rounded-md shadow focus:outline-none"
                            >
                                Login
                            </Button>
                        </div>
                    </form>
                </div>

                {/* Right Part */}
                <div className="hidden md:flex flex-col items-center justify-center w-full md:w-1/2 p-6 lg:w-[40%]">
                    <img
                        src="https://via.placeholder.com/400" // Replace with your image URL
                        alt="Contact Us"
                        className="rounded-lg shadow-lg"
                    />
                    <div className="mt-4 text-center">
                        <h2 className="text-xl font-semibold text-primary-color">Welcome Back</h2>
                        <p className="mt-2 text-white">
                            Log in to access your account and manage your profile, applications, and more.
                        </p>
                    </div>
                    <Image src={TestimonialsImage} alt="Contact Us" className="rounded-lg shadow-lg mt-[20px]" />
                </div>
            </div>

            <Footer />
        </>
    );
};

export default LoginRegister;